import {
  DB_DATE_FORMAT as CORE_DB_DATE_FORMAT,
  DEFAULT_DATE_FORMAT as CORE_DEFAULT_DATE_FORMAT,
  DEFAULT_TIME_FORMAT as CORE_DEFAULT_TIME_FORMAT,
} from "@utils/core";

export const DB_DATE_FORMAT = CORE_DB_DATE_FORMAT;
export const DEFAULT_TIME_FORMAT = CORE_DEFAULT_TIME_FORMAT;

const UI_TIME_FORMAT = CORE_DEFAULT_TIME_FORMAT.toLowerCase();
export const DEFAULT_DATE_FORMAT = `${CORE_DEFAULT_DATE_FORMAT}/YYYY` as const;
export const DEFAULT_DATETIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${UI_TIME_FORMAT}`;

export const WENT_WRONG = "Something went wrong. Please try again later.";
